module.exports = __webpack_public_path__ + "static/Chat_port_mobile-f797cc382457167baba5f28563062403.mp4";